export const api = function api_url() {
  return {
    API_URL: "http://localhost:8089/api"
  };
};
